/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import './styles.css';
import { getFamilies } from '../common/common';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import classNames from 'classnames';

interface State {
    productFamilies: any
    productnames: any
    productmodels: any
}
interface Props {
    selectedFamily: any
    selectedProductName: any
    selectedProductModel: any
    isLoading: any
    productModels: any
    productNames: any,
    families: any
    handleManualClassificationChange: Function
    UpdateProductFamilies: Function
}

const ProductFamily = 'selectedFamily';
const ProductName = 'selectedProductName';
const ProductModel = 'selectedProductModel';

const theme1 = createTheme({
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    paddingTop: 11,
                    paddingBottom: 11,
                    '&:hover': {
                        backgroundColor: '#e3f2fd'
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#e3f2fd',
                        '&:hover': {
                            backgroundColor: '#e3f2fd'
                        }
                    }
                }
            }
        }
    }
});

const styles = () => ({
    active: {
        backgroundColor: "#fff !important"
    },
    selectInput: {
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
        transition: "0.3s",
        height: 48,
        display: "flex",
        alignItems: "center",
        "& em": {
            fontSize: 14,
            fontStyle: "normal",
            marginLeft: 10
        }
    },
    elevatedInput: {
        zIndex: 100
    },
    inputLabel: {
        fontSize: 14,
        marginLeft: 10
    },
    enabledInputLabel: {
        fontFamily: "Roboto",
        color: "#000000DE",
    },
    selectHeight: {
        "& label": {
            fontSize: 14,
            fontStyle: "normal",
            color: "#262533 !important",
            transform: "translate(14px, -9px) scale(0.75)"
        }
    },
    classificationDropdown: {
        fontSize: 14,
        fontStyle: "normal"
    }
});

class ProductClassification extends React.Component<Props, State>{
    async componentDidMount() {
        let family = await getFamilies();
        this.props.UpdateProductFamilies(family.data);
    }
    handleChange = (event: any) => {
        this.props.handleManualClassificationChange(event);
    };
    getMenuProps = () => {
        let height = window.innerHeight;
        let marginTop = "1.0%";
        if (height > 800) {
            marginTop = "0.6%";
        }
        return {
            PaperProps: {
                style: {
                    maxHeight: "80%",
                    width: 200,
                    marginTop
                }
            }
        };
    };

    render() {
        if (this.props.families !== undefined) {
            return (
                <Grid>
                    {this.renderSelectMenus('Product Family', ProductFamily, this.props.families, this.props, this.props.isLoading)}
                    {this.renderSelectMenus('Product Name', ProductName, this.props.productNames, this.props, this.props[ProductFamily] === undefined || this.props.isLoading)}
                    {this.renderSelectMenus('Product Model', ProductModel, this.props.productModels, this.props, this.props[ProductName] === undefined || this.props.isLoading)}
                </Grid>
            );
        }
        else {
            return <div />;
        }
    }

    renderSelectMenus(displayName: any, title: any, list: any, props: any, disabled: boolean) {
        const valueExists = (props == undefined || props[title] == undefined);
        return (
            <ThemeProvider theme={theme1}>
            <FormControl variant="outlined" className={'productClassificationFormControl'}>
                    <Select
                    MenuProps={this.getMenuProps()}
                    disableUnderline={true}
                    id="demo-simple-select-outlined"
                    onChange={this.handleChange}
                    name={title}
                    value={props !== undefined && props[title] !== undefined ? props[title] : ''}
                    disabled={disabled}
                    classes={{ root: props.classes.selectInput}}
                    displayEmpty
                    renderValue={(value) => {
                        if (!value) {
                            return <em className="productClassificationFormControl" style={{ color: '#000' }}>{displayName}</em>;
                        }
                        return <em className="productClassificationFormControl">{list != undefined &&
                            list.map((x: any) => { return x.id == value && x.name; })
                        }</em>;
                    }}
                >
                    {list.map((x: any) => {
                        return <MenuItem key={x.id} value={x.id}>
                            <em className={props.classes.classificationDropdown}>{x.name}</em>
                        </MenuItem>;
                    })}
                </Select>
                </FormControl>
            </ThemeProvider>
        );

    }
}

export default (withStyles(styles)(ProductClassification));
